import ItemDetailsSFC from "./ItemDetails.vue";
export const ItemDetails = ItemDetailsSFC;
